import request from "./useRequests";
import { userinfo } from '@/stores/counter'
import { ElMessage } from 'element-plus'
import getStatus from '@/api/getStatus'

export default function uselogin() {
  const user = userinfo()
  const { status } = getStatus();
  async function login(mail: string, passwd: string) {
    if (mail == undefined || passwd == undefined) {
      ElMessage({
        showClose: true,
        message: '不能输入空字符',
        type: 'error',
      })
      return 0
    }
    try {
      const res = await request.post('/user/login', {
        "name": mail,
        "passWord": passwd,
      })
      if (res.data.success == true) {
        ElMessage({
          showClose: true,
          message: '登录成功',
          type: 'success',
        })
        status();
        user.login = true;
      } else {
        ElMessage({
          showClose: true,
          message: `${res.data.message}`,
          type: 'error',
        })
        // console.log(res)
      }
    } catch (err: any) {
      //alert(err)
    }
  }

  return {
    login
  }
}